/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames';
import {
    instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGamesFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGamesFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGamesToJSON,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames';

/**
 * @type FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGames
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGames = FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames;

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGames {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGames {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGamesFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGames | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGamesToJSON(value as FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames);
    }

    return {};
}

